// Google Ads conversion tracking helpers
// Tag ID: AW-18278364579
//
// WhatsApp conversion uses Google-provided snippet gtag_report_conversion(url)
// which lives in /public/index.html (do not modify).
//
// Phone conversion fires a generic conversion event. Once a dedicated phone
// conversion label is created in Google Ads, replace 'send_to' below.

const GADS_ID = "AW-18278364579";

function isWhatsAppHref(href) {
  return href.includes("wa.me/") || href.includes("api.whatsapp.com");
}

function trackPhoneConversion(phoneNumber) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: GADS_ID,
    event_category: "engagement",
    event_label: "Phone Call Click",
    phone_number: phoneNumber,
  });
  window.gtag("event", "phone_click", {
    event_category: "engagement",
    event_label: "Phone Call Click",
    phone_number: phoneNumber,
  });
}

/**
 * Global capturing-phase click listener. Intercepts:
 *  - WhatsApp links → calls window.gtag_report_conversion(url) (Google snippet)
 *    and falls back to window.open() if gtag is unavailable / blocked.
 *  - tel: links → fires phone_click conversion (snippet has no special handler).
 *
 * Returns cleanup function for useEffect.
 */
export function installGlobalClickTracking() {
  const handler = (e) => {
    const anchor = e.target.closest && e.target.closest("a[href]");
    if (!anchor) return;
    const href = (anchor.getAttribute("href") || "").trim();
    if (!href) return;

    // PHONE
    if (href.startsWith("tel:")) {
      trackPhoneConversion(href.replace("tel:", ""));
      return; // let browser handle tel: as usual
    }

    // WHATSAPP
    if (isWhatsAppHref(href)) {
      // Fire Google-provided conversion snippet which will navigate via callback.
      e.preventDefault();
      const target = anchor.getAttribute("target");

      // Failsafe: if gtag is blocked / not loaded, just navigate normally.
      if (typeof window.gtag_report_conversion !== "function") {
        if (target === "_blank") window.open(href, "_blank", "noopener,noreferrer");
        else window.location.href = href;
        return;
      }

      if (target === "_blank") {
        // Preserve "open in new tab" UX. Fire conversion without redirecting
        // the current page; open WhatsApp in a new tab in parallel.
        window.open(href, "_blank", "noopener,noreferrer");
        // Call the snippet without a URL so its callback is a no-op
        // (still records the conversion).
        window.gtag_report_conversion();
        return;
      }

      // Same-tab navigation: let snippet handle it (it navigates in callback).
      window.gtag_report_conversion(href);

      // Safety net in case event_callback never fires (e.g. blocked):
      // give it 1.2s then force navigation.
      setTimeout(() => {
        window.location.href = href;
      }, 1200);
    }
  };
  document.addEventListener("click", handler, true);
  return () => document.removeEventListener("click", handler, true);
}
